import { render, staticRenderFns } from "./read-only.vue?vue&type=template&id=d67df872&"
import script from "./read-only.vue?vue&type=script&lang=js&"
export * from "./read-only.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports